import { t } from "@travily/i18n";
import {
  type EditorCardData,
  type EditorCardRenderers,
  listingSectionCards,
} from "@/components/EditorSectionNav/cards";
import type { EditorNavSection } from "@/components/EditorSectionNav/EditorSectionNav";

// The server sends the ordered, listing-type-narrowed set from the field
// registry; this only turns each key into something renderable. Labels resolve
// dynamically so a new field needs no change here.
// i18n-tasks-use t('web.listings.fields.title.label')
// i18n-tasks-use t('web.listings.fields.tagline.label')
// i18n-tasks-use t('web.listings.fields.description.label')
// i18n-tasks-use t('web.listings.fields.photos.label')
// i18n-tasks-use t('web.listings.fields.content.label')
// i18n-tasks-use t('web.listings.fields.price_type.label')
// i18n-tasks-use t('web.listings.fields.price_amount.label')

export interface EditorSectionsData extends EditorCardData {
  sections: { href: string; key: string }[];
}

export function buildEditorSections(
  data: EditorSectionsData,
  cards: EditorCardRenderers = listingSectionCards,
): EditorNavSection[] {
  return data.sections.map(({ key, href }) => ({
    key,
    href,
    label: t(`web.listings.fields.${key}.label`),
    footer: cards[key]?.(data),
  }));
}
